import React, { useState } from 'react';
import PropTypes from 'prop-types';

// React Spectrum components
import {
  Button,
} from '@adobe/react-spectrum';

// CSS
import '../../styles/ViewPhoneNumberButton.scss';

const ViewPhoneNumberButton = ({ phoneNumber }) => {
  const [showingPhone, setShowingPhone] = useState(false);

  /**
   * renderButtonContent
   * Returns either "Show Phone Number" or the actual phone number
   * depending on the state.
   */
  const renderButtonContent = () => {
    // If state is default, show message.
    if (!showingPhone) {
      return (
        <div className="phoneText">
          Phone number
        </div>
      );
    }
    // Otherwise return the phone number.
    return <div className="phoneNumber">{phoneNumber}</div>;
  };

  /**
   * handleButtonPress
   * Handles the press event on a button.
   */
  const handleButtonPress = () => {
    setShowingPhone((prevState) => !prevState);
  };

  return (
    <Button
      variant="primary"
      data-test-id="view-phonenumber-button"
      onPress={handleButtonPress}
      UNSAFE_className="cmp-viewPhoneButton"
    >
      {renderButtonContent()}
    </Button>
  );
};

ViewPhoneNumberButton.propTypes = {
  phoneNumber: PropTypes.string,
};

ViewPhoneNumberButton.defaultProps = {
  phoneNumber: null,
};

export default ViewPhoneNumberButton;
